import React from 'react'
import { useSearchParamsHandler } from '~/contexts/FilterContext'
const PaginationContext = React.createContext()

export const PaginationProvider = ({
  children,
  totalPages,
  totalItems,
  prefix,
  scrollToTop = true,
}) => {
  const prefixRefined = prefix ? prefix + '-' : ''
  const { query, setQuery } = useSearchParamsHandler()
  const currentLimit = query[`${prefixRefined}limit`] || 10
  const currentPage = query[`${prefixRefined}page`] || 1

  const handleLimit = value => {
    setQuery(`${prefixRefined}limit`, value)
  }
  const pages = React.useMemo(() => {
    const allPages = Array.from({ length: totalPages }, (_, i) => i + 1)

    if (allPages.length > 6) {
      if (currentPage < 4) {
        return [...allPages.slice(0, 4), '...', totalPages]
      } else if (currentPage > totalPages - 3) {
        return [1, '...', ...allPages.slice(totalPages - 4)]
      } else {
        return [
          1,
          '...',
          ...allPages.slice(currentPage - 2, currentPage + 1),
          '...',
          totalPages,
        ]
      }
    } else {
      return [...allPages]
    }
  }, [currentPage, totalPages])

  const handleNextPage = () => {
    setQuery(`${prefixRefined}page`, currentPage + 1)
  }
  const handlePrevPage = () => {
    setQuery(`${prefixRefined}page`, currentPage - 1)
  }
  const handlePaginate = value => {
    setQuery(`${prefixRefined}page`, value)
  }

  React.useEffect(() => {
    if (currentPage > totalPages) {
      setQuery(`${prefixRefined}page`, 1)
    }
  }, [totalPages])

  React.useEffect(() => {
    const scrollElement = document.getElementById('scrool-to-top')
    if (scrollElement && scrollToTop) {
      scrollElement.scrollIntoView({ behavior: 'smooth' })
    }
  }, [currentPage, scrollToTop])
  return (
    <PaginationContext.Provider
      value={{
        handleNextPage,
        handlePrevPage,
        handlePaginate,
        handleLimit,
        currentLimit,
        currentPage,
        pages,
        totalPages,
        totalItems,
      }}
    >
      {children}
    </PaginationContext.Provider>
  )
}

export const usePaginationContext = () => {
  const context = React.useContext(PaginationContext)
  if (!context) {
    throw new Error(
      'usePaginationContext must be used within a PaginationProvider'
    )
  }
  const {
    handleNextPage,
    handlePrevPage,
    handlePaginate,
    handleLimit,
    currentLimit,
    currentPage,
    pages,
    totalPages,
    totalItems,
  } = context
  return {
    handleNextPage,
    handlePrevPage,
    handlePaginate,
    handleLimit,
    currentLimit,
    currentPage,
    pages,
    totalPages,
    totalItems,
  }
}
